/**
 * Draw Type
 */
export enum DrawType {
  /**
   * DrawLine
   */
  Polyline = 'line',
  /**
   * DrawPolygon
   */
  Polygon = 'polygon',
  /**
   * DrawPoint
   */
  Point = 'point',
  /**
   * DrawCircle
   */
  Circle = 'circle',
  /**
   * DrawRect
   */
  Rect = 'rect',
}
